/* ComponentModal template */
import { Host, h, FunctionalComponent } from '@stencil/core'; // eslint-disable-line @typescript-eslint/no-unused-vars
import { ModalComponent } from './cwc-modal';

/**
 * Definition of  parameters that the template needs to work.
 */
interface ModalTemplateProps {
  /**
   * The class instance that provides controller functionality for the template
   */
  controller: ModalComponent;

  /**
   * Enter or leave fullscreen mode
   */
  fullscreen: boolean;
  // Specify parameters that are required to be passed down to the template here.
  headerTextAlign: string;
  narrow: boolean;
}

const ModalTemplate: FunctionalComponent<ModalTemplateProps> = ({
  controller,
  fullscreen,
  headerTextAlign,
  narrow,
}) => (
  <Host>
    <dialog
      ref={(el: HTMLDialogElement) => (controller.dialogRef = el)}
      class={'cwc-modal' + (fullscreen ? ' cwc-modal--fullscreen' : '') + (narrow ? ' cwc-modal--narrow' : '')}
      onMouseDown={(e: MouseEvent) => controller.handleMouseDown(e)}
      onClick={(e: MouseEvent) => controller.handleClick(e)}
    >
      <button class="cwc-modal__close-button" autofocus onClick={() => controller.onClose()}>
        <slot name={'close-icon'}>
          <svg class="cwc-modal__close-icon" viewBox={'0 0 24 24'}>
            <path d="m13.41 12 5.66-5.66a.996.996 0 1 0-1.41-1.41L12 10.59 6.34 4.93a.996.996 0 1 0-1.41 1.41L10.59 12l-5.66 5.66a.996.996 0 0 0 .71 1.7c.26 0 .51-.1.71-.29l5.66-5.66 5.66 5.66c.2.2.45.29.71.29s.51-.1.71-.29a.996.996 0 0 0 0-1.41L13.43 12Z"></path>
          </svg>
        </slot>
      </button>
      <div class={'cwc-modal__header' + (headerTextAlign === 'left' ? ' cwc-modal__header--text-left' : '')}>
        <slot name="header-items" />
      </div>
      <div ref={(el: HTMLDivElement) => (controller.dialogBodyRef = el)} class="cwc-modal__body" tabindex="0">
        <slot />
      </div>
      <div class="cwc-modal__footer-wrapper">
        <div class="cwc-modal__footer">
          <slot name="footer-items" />
        </div>
      </div>
    </dialog>
  </Host>
);

export default ModalTemplate;
